document.addEventListener("DOMContentLoaded", function () {
  // لا تقم بتشغيل الكود في صفحة البحث
  if (window.location.pathname.includes("/search")) return;

  let isProcessing = false;

  function fixInfiniteScrollSorting() {
    if (isProcessing) return;
    isProcessing = true;

    // استخدام requestAnimationFrame لمنع تجميد الشاشة أثناء التمرير
    requestAnimationFrame(() => {
      const items = document.querySelectorAll(".collection .gitem");
      const counterEl = document.querySelector(".product_counter_z");
      const totalProducts = counterEl ? parseInt(counterEl.dataset.all) : 0;
      
      // فصل المنتجات المتاحة عن المنتهية
      items.forEach(item => {
        const isSoldOut = item.querySelector(".grid_bx.sold-out");
        if (isSoldOut) {
          item.style.order = "999"; // دفع للأسفل
          item.classList.add("hide-oos-temp"); // إخفاء مؤقت
        } else {
          item.style.order = "0"; // ترتيب طبيعي
        }
      });

      // التحقق مما إذا كان قد تم تحميل جميع المنتجات في المجموعة
      const containerPr = document.querySelector("#collectionPr");
      const childrenCount = containerPr ? containerPr.children.length : items.length;

      // إظهار المنتجات المنتهية دفعة واحدة في نهاية الصفحة فقط
      if (totalProducts > 0 && childrenCount >= totalProducts) {
        document.querySelectorAll(".hide-oos-temp").forEach(el => {
          el.classList.remove("hide-oos-temp");
        });
      }
      
      isProcessing = false;
    });
  }

  // تشغيل الكود لمرة واحدة عند الدخول
  fixInfiniteScrollSorting();

  // المراقبة الذكية: تعمل فقط عند سحب منتجات جديدة (AJAX) وليس عند أي تغيير بسيط
  const observer = new MutationObserver((mutations) => {
    let newElementsAdded = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        newElementsAdded = true;
      }
    });
    
    if (newElementsAdded) {
      fixInfiniteScrollSorting();
    }
  });

  // تفعيل المراقب على حاوية المنتجات
  document.querySelectorAll(".collection").forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
});
